<script>
export default {
}
</script>

<template>
    <div class="bags-price-checker-header">
        <span>BAG PRICE CHECKER</span>
        <span class="sub">*Required Fields</span>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .bags-price-checker-header {
        font-size: 22px;
        font-weight: 600;
        letter-spacing: 0.26px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: @white;
        border-bottom: 2px solid rgba(255,255,255, 0.25);
        padding-bottom: 10px;

        .sub {
            font-size: 11px;
            font-weight: 400;
            line-height: 14px;
        }
    }

    @media @tablet-lg {
        .bags-price-checker-header {
            font-size: 16px;
            padding-bottom: 12px;
        }
    }

    @media @tablet {
        .bags-price-checker-header {
            padding-bottom: 16px;

            .sub {
                font-size: 10px;
            }
        }
    }

    @media @mobile-sm {
        .bags-price-checker-header {
            font-size: 14px;
        }
    }
</style>